// --------------------------------------------------------------------------
// #TBC - Chart Selector Form
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------
//TODO: Get the data once onload and then pass through app


'use strict';

var $ = require('jquery');
var Handlebars = require('handlebars');
var ChartGenerator = require('./charting-generator');
var pictogramBlock = require('./charting-pictogram-block');
var chartTable = require('./charting-table');
var colours = require('./charting-graph-colours')();
var chartGenerator = new ChartGenerator();
var YearCodePrefix = require('./charting-year-code-pid-prefix');
var sortAndMatchBirdData = require('./charting-sort-and-match-bird-data');
var TableSort = require('./charting-tablesort');
var resetContainerHeight = require('./charting-reset-height');
var hideControls = require('./charting-hide-controls');

module.exports = function (options) {
	//NS
	var CHARTING_NAMESPACE = 'BSBW';
	var context = options.context;
	//DOM
	var $table;
	var $chartContainer = $('[data-binding="chart-container"]');
	var $dataOptionsForm = $('[data-bind="charting-form-data-set-options"]');
	var $dataPickerContainer = $('[data-bind="charting-data-picker"]');
	var $dataSizeOptions = $('[data-bind="charting-fieldset-data-size"]');
	var $chartPickerForm = $('[data-binding="charting-selector"]');
	var $dataRangeInput = $('[data-bind="data-size-options"]');
	//Error containers
	var $warningContainsNoData = $('[data-bind="charting-contains-no-data"]');
	var $warningNoType = $('[data-bind="charting-no-type-selected"]');
	var $warningDataError = $('[data-bind="charting-error-with-data"]');
	var $warningResourceError = $('[data-bind="charting-error-data-source"]');
	var $warningLoading = $('[data-bind="charting-loading"]');
	// Locale/culture code
	var currentCultureCode = $chartPickerForm.attr('data-current-culture-code');
	//App type
	var preview;
	//Data vars
	var maxDataSize = 25;
	//inits
	var buildTableChart = chartTable();

	/*
     ------------
     Constructors
     ------------
  */
	function HighChartObj(name) {
		this.name = name;
		this.data = [];
	}

	/*
 ------------
 Form handlers and error messages
 ------------
 */

	function noDataSelectionMessage() {
		resetContainerHeight();
		hideControls();
		$chartContainer.empty().append($warningContainsNoData);
	}

	function noChartTypeMessage() {
		resetContainerHeight();
		hideControls();
		$chartContainer.empty().append($warningNoType);
	}

	function dataRetrievalMessage() {
		resetContainerHeight();
		hideControls();
		$chartContainer.empty().append($warningDataError);
	}

	function dataResourceTypeMessage() {
		resetContainerHeight();
		hideControls();
		$chartContainer.empty().append($warningResourceError);
	}

	function showLoadingMessage() {
		resetContainerHeight();
		hideControls();
		$chartContainer.empty().append($warningLoading);
	}

	/*
     ---------
     Chart builders
     ---------
  */
	function createPicBlock(chartType, isEditable, dataDetail) {
		//Create pictogram & block
		var picBlockGenerator = pictogramBlock();
		var $picBlock = picBlockGenerator.init(dataDetail, chartType, isEditable);
		return $picBlock;
	}

	/*
 ------------
 Data formatters and helpers
 ------------
 */

	function populateDataDetail(data, loopSize) {
		//data detail is bird only data
		//for editbale charts
		//add colours to each data node
		for (var i = 0; i < loopSize; i++) {
			data.birds[i].colour = '#' + colours[i];
		}
		data.birds.splice(loopSize, data.birds.length - loopSize);
		return data.birds;
	}

	function getBirdNames(data, loopSize) {
		//Create axis names
		var birdNames = [];
		for (var i = 0; i < loopSize; i++) {
			birdNames.push(data.birds[i].name);
		}
		return birdNames;
	}

	function getDatasetNames(dataArr) {
		var namesArray = [];
		for (var i = 0; i < dataArr.length; i++) {
			if (dataArr[i].name !== undefined) {
				namesArray.push(dataArr[i].name);
			} else {
				namesArray.push('Results Overall ' + dataArr[i].year);
			}
		}
		return namesArray;
	}

	function getSeriesData(dataArr, loopSize) {
		//Loop through data array
		var seriesData = [];
		for (var j = 0; j < dataArr.length; j++) {
			//Create object suitable for Highcharts
			var thisDataObj = new HighChartObj(dataArr[j].year);

			for (var k = 0; k < loopSize; k++) {
				//Handle disparities between data sets
				if (dataArr[j].birds[k] === undefined) {
					dataArr[j].birds[k] = { count: 0 };
				}
				thisDataObj.data.push(dataArr[j].birds[k].count);
				//thisDataObj.data.push({x: dataArr[j].birds[k].count, color: '#' + colours[k]});
			}
			seriesData.push(thisDataObj);
		}
		return seriesData;
	}

	function isAdv(checkedBox) {
		//If there's at least one checkbox
		if (checkedBox !== undefined) {
			var advString = checkedBox.attr('id').split('').splice(0, 3).join('');
			return advString === 'adv';
		}
		//Output error
		else {
				noChartTypeMessage();
				return false;
			}
	}

	function getInitialSelectState() {
		var stringHtml = document.getElementById('full-data-select-template').innerHTML;
		var template = Handlebars.compile(stringHtml);
		var html = template();

		return html;
	}

	function removeDataSelects() {
		//remove all but the first select menu
		var dataPickers = $('[data-bind="charting-data-picker"]');

		if (dataPickers.length > 1) {
			dataPickers.slice(1).remove();
		}
	}

	function createNewDataSelect(newElsNum) {
		//create a number of new select menus
		//using Hbs based on newElsNum
		removeDataSelects();
		var html = getInitialSelectState();

		for (var i = 0; i < newElsNum; i++) {
			$dataPickerContainer.after(html);
		}
	}

	function createChartTypeCheck() {
		//Handle the form logic
		var typeInputs = $('input[type="radio"]', context);
		var selectedInput = typeInputs.filter(':checked');
		//If no type is selected alert the user
		//and stop running
		if (selectedInput.length === 0) {
			noChartTypeMessage();
			return false;
		}
		//Or return an object
		//with the type as string
		//and a jQuery object
		else {
				return {
					type: selectedInput.data('type'),
					$input: selectedInput
				};
			}
	}

	function dataSetSelectInit() {
		$chartPickerForm.on('change', 'input[type="radio"]', function () {
			var chartType = createChartTypeCheck();

			if (chartType.type === 'table' && isAdv(chartType.$input)) {
				createNewDataSelect(2);
			} else if (chartType.type === 'bar' && isAdv(chartType.$input)) {
				createNewDataSelect(1);
			} else {
				removeDataSelects();
			}
		});
	}

	//Make partials available
	//Has to be ready before other apps use it
	//Could be cleaner
	function initPartials() {
		Handlebars.registerPartial('controls', $('#controls-partial').html());
		Handlebars.registerPartial('controlIncrease', $('#controls-input__button-increase').html());
		Handlebars.registerPartial('controlDecrease', $('#controls-input__button-decrease').html());
		Handlebars.registerPartial('controlsh', $('#controlsh-partial').html());
	}

	function renderCharts(type, editable, surveyCodePrefix, seriesData, axisLabels, dataDetail, dataSetNames) {
		//render charts
		if (type === 'table') {
			//if in preview mode
			//just render the original table
			if (preview === true) {
				$chartContainer.empty().append($table);
			}
			//else build and store one
			//using the hbs tmpl
			else {
					var hbsTable = buildTableChart.init(seriesData, axisLabels, dataSetNames);
					$chartContainer.empty().append(hbsTable);
					resetContainerHeight();
					new TableSort(document.querySelectorAll('[data-binding="charting-table-chart"]')[0], {
						descending: true
					});
				}
			resetContainerHeight();
			hideControls();
		}
		//
		else if (type === 'pictogram' || type === 'block') {
				var $picBlock = createPicBlock(type, editable, dataDetail);
				resetContainerHeight();
				hideControls();
				$chartContainer.empty().append($picBlock);
			}
			//generate the relevent Highcharts chart
			else {
					//Use column chart if alternating colours are required
					if (type === 'bar') {
						type = 'column';
					}
					chartGenerator.loadChart(type, surveyCodePrefix, axisLabels, seriesData, dataDetail, editable);
				}
	}

	/*
 	------------
 	Data getter
 	------------
  */

	function getResourceTypeUrlString(resourceType) {
		var chartTypeURLString = '';
		if (resourceType === 'national') {
			chartTypeURLString = 'surveyAggregates';
		} else if (resourceType === 'personal') {
			chartTypeURLString = 'surveyEntries';
		} else {
			dataResourceTypeMessage();
		}
		return chartTypeURLString;
	}

	function prepareData(dataArr) {
		//Before the data is processed
		//Get data set names
		var dataSetNames = getDatasetNames(dataArr);
		//Sort by most popular birds and pad/remove data from secondary sets that don't match birds in the first
		var sortedAndMatchedDataSets = sortAndMatchBirdData(dataArr);
		//get chart type
		var chartType = createChartTypeCheck();
		//find first dataset - this is the main one that others will be compared with
		var firstSet = sortedAndMatchedDataSets[0];
		//Check that the set contains any data
		if (firstSet === undefined || firstSet === 0) {
			noDataSelectionMessage();
			return;
		}

		//If chart is for juniors
		var thisMaxDataSize = maxDataSize;
		if (isAdv(chartType.$input) === false) {
			thisMaxDataSize = 5;
		}
		//or use default value
		else {
				thisMaxDataSize = $('option:selected', $dataRangeInput).val();
			}

		var loopSize = firstSet.birds.length;
		if (loopSize > thisMaxDataSize) {
			loopSize = thisMaxDataSize;
		}

		//format data for Highcharts
		var birdNames = getBirdNames(firstSet, loopSize);
		var seriesDataObj = getSeriesData(sortedAndMatchedDataSets, loopSize);

		//For use with editable charts
		var dataDetail;
		//If single data set
		if (sortedAndMatchedDataSets.length === 1) {
			dataDetail = populateDataDetail(sortedAndMatchedDataSets[0], loopSize);
		}
		//set vars for clarity
		var axisLabels = birdNames;
		var editable = !isAdv(chartType.$input);
		renderCharts(chartType.type, editable, CHARTING_NAMESPACE, seriesDataObj, axisLabels, dataDetail, dataSetNames);
	}

	function getData(yearCodePrefixObj) {
		//Contianer array for XHR JSON requests
		var requests = [];
		//Show loading message
		//Until chart repalces it
		showLoadingMessage();
		//Get the year or personal ID
		//as key for API end point
		var yearPIDs = yearCodePrefixObj.yearPID;
		var resourceTypes = yearCodePrefixObj.resourceType;
		//Make a request for each data set
		for (var i = 0; i < yearPIDs.length; i++) {
			var resourceTypeUrl = getResourceTypeUrlString(resourceTypes[i]);
			var url = '/api/charting/' + resourceTypeUrl + '/' + CHARTING_NAMESPACE + '/' + yearPIDs[i] + '?epslanguage=' + currentCultureCode;
			requests.push($.getJSON(url));
		}

		$.when.apply($, requests).done(function () {
			var total = 0;
			var dataSets = [];
			$.each(arguments, function (i, data) {
				total += 1;
				//Ensure data is an array
				//When single checkbox is uses
				//The data comes back as an object
				//TODO investigate this issue
				if (!$.isArray(data)) {
					data = new Array(data);
				}
				dataSets.push(data[0]);
				//when all the data has been retrieved
				//format it
				if (total === yearPIDs.length) {
					prepareData(dataSets);
				}
			});
		}).fail(function () {
			dataRetrievalMessage();
		});
	}

	function togglePrintDownloadButtonsInit() {
		var buttons = $('[data-behavior="charting-print-chart"]').hide();
		var printButton = buttons.filter('[data-action="print"]');
		var downloadButton = buttons.filter('[data-action="download"]');

		buttons.hide();

		$chartPickerForm.on('change', 'input[type="radio"]', function () {
			var type = $(this).attr('id');
			if (type === 'basic-pictogram' || type === 'basic-block' || type === 'adv-table') {
				printButton.show();
				downloadButton.hide();
			} else if (type === 'basic-bar' || type === 'basic-pie' || type === 'adv-bar' || type === 'adv-pie') {
				downloadButton.show();
				printButton.hide();
			}
		});
	}

	function chartDataRangeInit() {
		$(context).on('change', 'input[type="radio"]', function () {
			if (isAdv($(this))) {
				$dataSizeOptions.show();
			} else {
				$dataSizeOptions.hide();
			}
		});
	}

	function chartDataFormReveal() {
		//Handle the form logic
		$(context).on('change', 'input[type="radio"]', function () {
			$('[data-bind="charting-data-set-wrapper"] [data-binding="form-content"]').show();
			$warningNoType.remove();
		});
	}

	function getSelectedDataProps() {
		var $dataSelects = $dataOptionsForm.find('select');
		var selectedValuesArr = [];
		var selectedElDataArr = [];

		$dataSelects.each(function () {
			var selectedOptionsVal = $('option:selected', $(this)).val();
			var selectedElData = $('option:selected', $(this)).data('dataset-type');
			selectedValuesArr.push(selectedOptionsVal);
			selectedElDataArr.push(selectedElData);
		});

		return {
			selectedValuesArr: selectedValuesArr,
			selectedElDataArr: selectedElDataArr
		};
	}

	function handleSubmit() {
		$('[data-bind="submit"]').on('click', function () {
			//if there's a chart type selected
			var chartType = createChartTypeCheck();
			if (chartType !== false) {
				var dataProps = getSelectedDataProps();
				//TODO - stop using namespace
				//and use data atribute from page or url
				var yearCodePrefix = new YearCodePrefix(dataProps.selectedValuesArr, CHARTING_NAMESPACE, dataProps.selectedElDataArr);
				var chartingContainerOffset = $('[data-binding="chart-container"]').offset().top;
				$('html, body').animate({
					scrollTop: chartingContainerOffset
				}, 1000);
				getData(yearCodePrefix);
			}
		});
	}

	/*
 	---------
 	App Init
 	---------
  */

	function init() {
		initPartials();
		$dataSizeOptions.hide();
		//On preview page use the query string
		if ($('[data-page="charting-preview"]').length > 0) {}
		//Init if chart preview work gets signed off

		//On the create page use the form values only
		else if ($('[data-page="charting-create"]').length > 0) {
				preview = false;
				dataSetSelectInit();
				togglePrintDownloadButtonsInit();
				chartDataRangeInit();
				chartDataFormReveal();
				handleSubmit();
			}
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-selector.js
// module id = 233
// module chunks = 0